/**
 * Headlight Platform Configuration — Master List categories + addable candidates.
 *
 * CATEGORIES: the domains a reference list can be filed under. They drive the grouping
 * in the Manage Lists tool and the Reference Data navigation tree (one node per
 * non-empty category).
 *
 * CANDIDATES: reference/catalog entities an admin can turn into a managed list from the
 * tool. These are entities NOT already managed by the app's built-in recordsets — a
 * curated, categorized starting set. (Any entity name can still be added by hand via
 * the tool's free-text field; this list is just the friendly menu.)
 */

const CATEGORIES =
[
	{ Name: 'Materials & Mixes', Icon: 'fas fa-cube' },
	{ Name: 'Products & Production', Icon: 'fas fa-industry' },
	{ Name: 'Organizations & People', Icon: 'fas fa-building' },
	{ Name: 'Projects & Contracts', Icon: 'fas fa-file-contract' },
	{ Name: 'Pay & Funding', Icon: 'fas fa-dollar-sign' },
	{ Name: 'Labs & Equipment', Icon: 'fas fa-flask' },
	{ Name: 'Tests & Specifications', Icon: 'fas fa-vial' },
	{ Name: 'Data & Assets', Icon: 'fas fa-layer-group' },
	{ Name: 'Physical Assets', Icon: 'fas fa-cubes' },
	{ Name: 'Reports & Dashboards', Icon: 'fas fa-chart-line' },
	{ Name: 'Academy', Icon: 'fas fa-graduation-cap' },
	{ Name: 'Lookups & Types', Icon: 'fas fa-tags' },
	{ Name: 'Uncategorized', Icon: 'fas fa-folder' }
];

const CANDIDATES =
[
	{ Entity: 'MixDesign', Label: 'Mix Designs', Domain: 'Materials & Mixes', Icon: 'fas fa-flask-vial' },
	{ Entity: 'MixSpecification', Label: 'Mix Specifications', Domain: 'Materials & Mixes', Icon: 'fas fa-clipboard-list' },
	{ Entity: 'Stockpile', Label: 'Stockpiles', Domain: 'Materials & Mixes', Icon: 'fas fa-mountain' },

	{ Entity: 'Contact', Label: 'Contacts', Domain: 'Organizations & People', Icon: 'fas fa-address-card' },

	{ Entity: 'ProjectOffice', Label: 'Project Offices', Domain: 'Projects & Contracts', Icon: 'fas fa-location-dot' },

	{ Entity: 'BidItem', Label: 'Bid Items', Domain: 'Pay & Funding', Icon: 'fas fa-gavel' },
	{ Entity: 'FundingSource', Label: 'Funding Sources', Domain: 'Pay & Funding', Icon: 'fas fa-hand-holding-dollar' },
	{ Entity: 'Fund', Label: 'Funds', Domain: 'Pay & Funding', Icon: 'fas fa-piggy-bank' },
	{ Entity: 'FundingCategory', Label: 'Funding Categories', Domain: 'Pay & Funding', Icon: 'fas fa-folder-tree' },
	{ Entity: 'Account', Label: 'Accounts', Domain: 'Pay & Funding', Icon: 'fas fa-book' },
	{ Entity: 'AccountType', Label: 'Account Types', Domain: 'Pay & Funding', Icon: 'fas fa-list-ul' },

	{ Entity: 'Equipment', Label: 'Equipment', Domain: 'Labs & Equipment', Icon: 'fas fa-screwdriver-wrench' },
	{ Entity: 'Device', Label: 'Devices', Domain: 'Labs & Equipment', Icon: 'fas fa-tablet-screen-button' },

	{ Entity: 'TestSpecificationSet', Label: 'Test Specification Sets', Domain: 'Tests & Specifications', Icon: 'fas fa-vials' },
	{ Entity: 'TestPlan', Label: 'Test Plans', Domain: 'Tests & Specifications', Icon: 'fas fa-list-check' },

	{ Entity: 'Module', Label: 'Modules', Domain: 'Data & Assets', Icon: 'fas fa-puzzle-piece' },
	{ Entity: 'Layer', Label: 'Layers', Domain: 'Data & Assets', Icon: 'fas fa-layer-group' },
	{ Entity: 'LayerSet', Label: 'Layer Sets', Domain: 'Data & Assets', Icon: 'fas fa-clone' },
	{ Entity: 'DataSet', Label: 'Data Sets', Domain: 'Data & Assets', Icon: 'fas fa-database' },

	{ Entity: 'ReportArchetype', Label: 'Report Archetypes', Domain: 'Reports & Dashboards', Icon: 'fas fa-file-lines' },
	{ Entity: 'Dashboard', Label: 'Dashboards', Domain: 'Reports & Dashboards', Icon: 'fas fa-gauge-high' },

	{ Entity: 'AcademyLearningProgression', Label: 'Learning Progressions', Domain: 'Academy', Icon: 'fas fa-road' },
	{ Entity: 'AcademyObjective', Label: 'Learning Objectives', Domain: 'Academy', Icon: 'fas fa-bullseye' },
	{ Entity: 'AcademyLesson', Label: 'Lessons', Domain: 'Academy', Icon: 'fas fa-chalkboard' },
	{ Entity: 'AcademyContent', Label: 'Lesson Content', Domain: 'Academy', Icon: 'fas fa-photo-film' },
	{ Entity: 'AcademyTips', Label: 'Tips', Domain: 'Academy', Icon: 'fas fa-lightbulb' },

	{ Entity: 'JobType', Label: 'Job Types', Domain: 'Lookups & Types', Icon: 'fas fa-tag' },
	{ Entity: 'ListDefault', Label: 'List Defaults', Domain: 'Lookups & Types', Icon: 'fas fa-list' },
	{ Entity: 'IntegrationAdapter', Label: 'Integration Adapters', Domain: 'Lookups & Types', Icon: 'fas fa-plug' }
];

module.exports = { CATEGORIES, CANDIDATES };
